import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getAccountId, userIsLoggedIn } from 'store/currentUser/selectors'

import { InvoiceRedirect } from './InvoiceRedirect'
import { useRedirectData } from './PublicInvoice.queries'

const PublicInvoicePage = () => {
  const { uuid } = useParams<{ uuid: string }>()
  const isLoggedIn = useSelector(userIsLoggedIn)
  const accountId = useSelector((state) => getAccountId(state))
  const { redirectData, loading } = useRedirectData({
    accountId,
    uuid: uuid ?? '',
  })

  return (
    <InvoiceRedirect
      loading={loading}
      isLoggedIn={!!accountId || isLoggedIn}
      hasVisibility={
        !!accountId &&
        (redirectData?.retailerId === accountId.toString() ||
          redirectData?.brandId === accountId.toString())
      }
      orderId={redirectData?.orderId!}
    />
  )
}

export default PublicInvoicePage
